var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworkInterfaceDeviceFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9v10h3v2h2v2h6v-2h2v-2h3V9H8zm18 12h-3v2h-2v2H11v-2H9v-2H6V7h20v14z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9h1.5v4H10V9zM13.5 9H15v4h-1.5V9zM17 9h1.5v4H17V9zM20.5 9H22v4h-1.5V9z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiByeD0iNiIgZmlsbD0iY3VycmVudENvbG9yIi8+CjxwYXRoIGQ9Ik04IDlWMTlIMTFWMjFIMTNWMjNIMTlWMjFIMjFWMTlIMjRWOUg4Wk0yNiAyMUgyM1YyM0gyMVYyNUgxMVYyM0g5VjIxSDZWN0gyNlYyMVoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xMCA5SDExLjVWMTNIMTBWOVoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xMy41IDlIMTVWMTNIMTMuNVY5WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTE3IDlIMTguNVYxM0gxN1Y5WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTIwLjUgOUgyMlYxM0gyMC41VjlaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgNetworkInterfaceDeviceFill as ReactComponent };